<template>
<div>
  <form>
    <div class="columns">
      <div class="column">
        <text-input
          required
          :value="software.name"
          :error="$root.errorBag.name"
          placeholder="PHP"
          @input="updateName">Name</text-input>
      </div>
      <div class="column is-3">
        <text-input
          required
          :value="software.cpe_identifier"
          :error="$root.errorBag.cpe_identifier"
          placeholder="php:php"
          @input="updateCpeIndentifier">Software Version Identifier</text-input>
      </div>
      <div class="column is-3">
        <data-selector
          required
          no-revert
          :items="classifications"
          :value="software.cpe_classification"
          :error="$root.errorBag.cpe_classification"
          placeholder="a"
          @input="updateCpeClassification">
          Product Classification
        </data-selector>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <text-input
          required
          :value="software.version_regex"
          :error="$root.errorBag.version_regex"
          placeholder="/(\d{1,3}\.\d{1,3}(?:\.\d{1,3})?)/i"
          description="We need to parse the version number out string data."
          @input="updateVersionRegex">Version REGEX</text-input>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <submit-button :working="working" @submit="update">Save</submit-button>
      </div>
    </div>
  </form>
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {

  data: () => ({
    loading: true,
    working: false,
    updatingNist: false,
    nistDisabled: false,
    updatingCves: false,
    classifications: [
      { value: 'a', label: 'Application' },
      { value: 'o', label: 'Operating System' },
    ]
  }),

  beforeCreate() {
    Promise.all([
      this.$store.dispatch('software/loadSoftware', this.$route.params.software),
      this.$store.dispatch('attributeType/loadAttributeTypeList')
    ]).then(() => {
      this.loading = false
    })
  },

  beforeDestroy() {
    this.clearProduct()
  },

  methods: {
    ...mapMutations('software', [
      'updateName',
      'clearProduct',
      'updateCpeIndentifier',
      'updateCpeClassification',
      'updateVersionRegex',
      'updateAppMeta'
    ]),
    update() {
      this.working = true
      this.$store.dispatch('software/update').then(() => {
        this.$toast.success('saved')
        this.working = false
      }).catch(error => {
        this.$toast.error('try again')
        this.working = false
      })
    }
  },

  computed: {
    ...mapGetters('software', [
      'software'
    ]),
    ...mapGetters('attributeType', [
      'attributeTypeList'
    ]),
    softwareList() {
      return this.attributeTypeList.filter(meta => meta.type === 'software')
    }
  }

}
</script>
